
import React from 'react';
import { BrandCard, CardHeader, CardContent, CardTitle, CardDescription } from '@/components/ui/brand';
import { BrandButton, BrandIcon } from '@/components/ui/brand';
import { UserPlus, FileText, MessageSquare, Settings, BarChart3 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuickActionsGrid = () => {
  const navigate = useNavigate();
  
  const quickActions = [
    {
      title: "Hire New AI Staff",
      description: "Add specialized AI assistants to your team",
      icon: UserPlus,
      action: () => navigate('/app/staff'),
      buttonText: "Hire Staff",
      color: "primary"
    },
    {
      title: "Create Content",
      description: "Generate marketing materials and content",
      icon: FileText,
      action: () => navigate('/app/content-generator'),
      buttonText: "Start Creating",
      color: "primary"
    },
    {
      title: "Manage Integrations",
      description: "Connect your AI staff to other platforms",
      icon: Settings,
      action: () => navigate('/app/integrations'),
      buttonText: "Manage",
      color: "primary"
    },
    {
      title: "Chat with AI",
      description: "Talk to your AI assistants directly",
      icon: MessageSquare,
      action: () => navigate('/app/chat'),
      buttonText: "Open Chat",
      color: "primary"
    }
  ];
  
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions.map((action, index) => (
          <BrandCard key={index} className="h-full" animation="fade-in">
            <CardHeader className="pb-2">
              <div className="flex justify-between items-start">
                <CardTitle className="text-base font-medium">{action.title}</CardTitle>
                <BrandIcon icon={action.icon} color={action.color as any} background />
              </div>
              <CardDescription className="text-sm mt-2">{action.description}</CardDescription>
            </CardHeader>
            <CardContent className="pt-0">
              <BrandButton 
                variant="default" 
                className="w-full mt-2"
                onClick={action.action}
              >
                {action.buttonText}
              </BrandButton>
            </CardContent>
          </BrandCard>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsGrid;
